import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="mt-32 border-t border-white/5"
            data-testid="main-footer"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-16 pt-14 pb-4 text-center">
                {/* Affiliation / ethos statement — visible on every page */}
                <p
                    className="font-poetic text-sm md:text-base text-[#9a958a] leading-relaxed max-w-2xl mx-auto"
                    data-testid="footer-ethos"
                >
                    Angel Squad Inspirations is not affiliated with any Church or
                    religious denomination.
                </p>
                <p
                    className="mt-3 font-serif-display italic text-base md:text-lg text-[#e8e4db]"
                    data-testid="footer-ethos-affirmation"
                >
                    &ldquo;We, the Angel Squad members, are the Church.&rdquo;
                </p>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-10 pb-28 md:pb-24 flex flex-col items-center gap-6 border-t border-white/5 mt-6">
                <nav
                    className="flex flex-wrap items-center justify-center gap-x-6 sm:gap-x-8 gap-y-2 font-label text-[12px] md:text-[13px] tracking-[0.2em] uppercase text-[#cfa052]"
                    aria-label="Site policy links"
                >
                    <Link
                        to="/contact"
                        className="px-3 py-2 hover:text-[#e8e4db] transition-colors"
                        data-testid="footer-contact"
                    >
                        Contact
                    </Link>
                    <Link
                        to="/privacy"
                        className="px-3 py-2 hover:text-[#e8e4db] transition-colors"
                        data-testid="footer-privacy"
                    >
                        Privacy
                    </Link>
                    <Link
                        to="/terms"
                        className="px-3 py-2 hover:text-[#e8e4db] transition-colors"
                        data-testid="footer-terms"
                    >
                        Terms
                    </Link>
                    <Link
                        to="/delete-account"
                        className="px-3 py-2 hover:text-[#e8e4db] transition-colors"
                        data-testid="footer-delete-account"
                    >
                        Delete account
                    </Link>
                </nav>
                <div className="font-poetic text-sm text-[#6e6a62] text-center">
                    A private portal · members only · {new Date().getFullYear()}
                </div>
            </div>
        </footer>
    );
}
